import { Compiler, Injectable } from '@angular/core';
import { HorNavbarService } from '../../../core/service/hor-navbar.service';
import { CookieService } from 'ngx-cookie-service';
import { OrganizationsService } from '../../organization/components/service/organizations.service';

@Injectable({
  providedIn: 'root',
})
export class ResetAllDataService {
  constructor(
    private navbarService: HorNavbarService,
    private orgService: OrganizationsService,
    private _compiler: Compiler,
    private cookie: CookieService,
  ) { }

  reset(): void {
    localStorage.clear();
    // don't clear the session storage, look at session-expiration.service.ts
    this.cookie.deleteAll();
    this.navbarService.resetPeriods();
    this.orgService.resetAllData();

    this._compiler.clearCache();
  }

}
